/* eslint-disable object-curly-newline */
/* eslint-disable indent */
/* eslint-disable linebreak-style */
// eslint-disable-next-line import/extensions
import { TECHNICAL_INDICATORS, FOREX_LIST } from "@/assets/apiDocs/api_constants.js";

const globalConstants = {
  MIN_PASSWORD_LENGTH: 10,

  // BASE_URL: 'http://localhost:8888/api/',
  BASE_URL: "https://api.unibit.ai/api/",
  STRIPE_KEY: "pk_live_hiZtl12AMwYL08PzWoSSMqiz",
  // test key
  // STRIPE_KEY: 'pk_test_sOaHIv0RfGlGJwIJXdOlB0O0',

  // OAUTH_GOOGLE_REDIRECT_URL: "https://localhost:8080/insight/company/tearsheet",
  // OAUTH_GOOGLE_REDIRECT_URL: "https://unibit.ai/insight/company/tearsheet",
  OAUTH_GOOGLE_REDIRECT_URL: "https://unibit.ai/solution",
  // OAUTH_LINKEDIN_REDIRECT_URL: "https://localhost:8080/insight/company/tearsheet",
  // OAUTH_LINKEDIN_REDIRECT_URL: "https://unibit.ai/insight/company/tearsheet",
  OAUTH_LINKEDIN_REDIRECT_URL: "https://unibit.ai/solution",

  FOREX_LIST: FOREX_LIST,
  ECINDICATORS_MAP: {
    "U.S Data": [
      "Production & Business Activity",
      "National Accounts",
      "Money, Banking, & Finance",
      "U.S. Regional Data",
      "Prices",
      "Population, Employment, & Labor Markets",
      "Others"
    ],
    "International Data": ["Countries", "Geography", "Indicators", "Institutions"],
    "Academic Data": [
      "NBER Macrohistory Database",
      "Penn World Table 9.0",
      "Economic Policy Uncertainty",
      "Penn World Table 7.1",
      "Sticky Wages and Comovement",
      "Weekly U.S. and State Bond Prices, 1855-1865",
      "Others",
      "Recession Probabilities",
      "Banking and Monetary Statistics 1914-1941",
      "Data on the nominal term structure model from Kim and Wright",
      "Historical Federal Reserve Data",
      "A Millennium of Macroeconomic Data for the UK"
    ]
  },
  POPULAR_FOREX: ["USD", "EUR", "CNY", "GBP", "CAD"],
  UNITS: { B: 10 ** 6, T: 10 ** 9, M: 10 ** 3, K: 1 },
  plan: { 0: "Starter", 100: "Pro" },
  COUNTRYLIST: [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia, Plurinational State of",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Caribbean Netherlands",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo, Democratic Republic of the",
    "Congo, Republic of the",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Curaçao",
    "Cyprus",
    "Czech Republic",
    "Côte d’Ivoire",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern Territories",
    "Gabon",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Heard Island and McDonald Islands",
    "Holy See (Vatican City State)",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran, Islamic Republic of",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea, Democratic People's Republic of (North Korea)",
    "Korea, Republic of (South Korea)",
    "Kosovo",
    "Kuwait",
    "Kyrgyz Republic",
    "Lao People's Democratic Republic",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libyan Arab Jamahiriya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Macedonia, Former Yugoslav Republic of",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia, Federated States of",
    "Moldova, Republic of",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territories",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of the Gambia",
    "Reunion",
    "Romania",
    "Russian Federation",
    "Rwanda",
    "Saint Helena, Ascension and Tristan da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin, Collectivity of",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten (Dutch part)",
    "Slovak Republic",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania, United Republic of",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela, Bolivarian Republic of",
    "Viet Nam",
    "Virgin Islands, British",
    "Virgin Islands, U.S.",
    "Wallis and Futuna",
    "Western Sahara",
    "Yemen, Republic of",
    "Zambia",
    "Zimbabwe"
  ],
  ECAD_CATEGORYA: [
    {
      id: 12,
      category_a_name: "A Millennium of Macroeconomic Data for the UK"
    },
    {
      id: 9,
      category_a_name: "Banking and Monetary Statistics 1914-1941"
    },
    {
      id: 10,
      category_a_name: "Data on the nominal term structure model from Kim and Wright"
    },
    {
      id: 3,
      category_a_name: "Economic Policy Uncertainty"
    },
    {
      id: 11,
      category_a_name: "Historical Federal Reserve Data"
    },
    {
      id: 1,
      category_a_name: "NBER Macrohistory Database"
    },
    {
      id: 7,
      category_a_name: "Others"
    },
    {
      id: 4,
      category_a_name: "Penn World Table 7.1"
    },
    {
      id: 2,
      category_a_name: "Penn World Table 9.0"
    },
    {
      id: 8,
      category_a_name: "Recession Probabilities"
    },
    {
      id: 5,
      category_a_name: "Sticky Wages and Comovement"
    },
    {
      id: 6,
      category_a_name: "Weekly U.S. and State Bond Prices, 1855-1865"
    }
  ],
  ECAD_CATEGORYB: [
    {
      category_a_id: 12,
      category_a_name: "A Millennium of Macroeconomic Data for the UK",
      category_b_id: 56,
      category_b_name: "Financial Markets",
      popularity_sum: 327
    },
    {
      category_a_id: 12,
      category_a_name: "A Millennium of Macroeconomic Data for the UK",
      category_b_id: 53,
      category_b_name: "Money and Credit",
      popularity_sum: 183
    },
    {
      category_a_id: 12,
      category_a_name: "A Millennium of Macroeconomic Data for the UK",
      category_b_id: 52,
      category_b_name: "National Accounts",
      popularity_sum: 174
    },
    {
      category_a_id: 12,
      category_a_name: "A Millennium of Macroeconomic Data for the UK",
      category_b_id: 54,
      category_b_name: "Labour, Capital and Productivity",
      popularity_sum: 169
    },
    {
      category_a_id: 12,
      category_a_name: "A Millennium of Macroeconomic Data for the UK",
      category_b_id: 50,
      category_b_name: "Wages and Prices",
      popularity_sum: 131
    },
    {
      category_a_id: 12,
      category_a_name: "A Millennium of Macroeconomic Data for the UK",
      category_b_id: 51,
      category_b_name: "Trade",
      popularity_sum: 27
    },
    {
      category_a_id: 12,
      category_a_name: "A Millennium of Macroeconomic Data for the UK",
      category_b_id: 55,
      category_b_name: "Fiscal",
      popularity_sum: 27
    },
    {
      category_a_id: 11,
      category_a_name: "Historical Federal Reserve Data",
      category_b_id: 49,
      category_b_name: "Historical Federal Reserve Data",
      popularity_sum: 7
    },
    {
      category_a_id: 10,
      category_a_name: "Data on the nominal term structure model from Kim and Wright",
      category_b_id: 48,
      category_b_name: "Data on the nominal term structure model from Kim and Wright",
      popularity_sum: 295
    },
    {
      category_a_id: 9,
      category_a_name: "Banking and Monetary Statistics 1914-1941",
      category_b_id: 47,
      category_b_name: "Section 1. General Statistics of All Banks in the United States",
      popularity_sum: 618
    },
    {
      category_a_id: 9,
      category_a_name: "Banking and Monetary Statistics 1914-1941",
      category_b_id: 46,
      category_b_name: "Section 2. Assets and Liabilities of All Member Banks",
      popularity_sum: 368
    },
    {
      category_a_id: 8,
      category_a_name: "Recession Probabilities",
      category_b_id: 45,
      category_b_name: "Recession Probabilities",
      popularity_sum: 241
    },
    {
      category_a_id: 7,
      category_a_name: "Others",
      category_b_id: 44,
      category_b_name: "Others",
      popularity_sum: 36
    },
    {
      category_a_id: 6,
      category_a_name: "Weekly U.S. and State Bond Prices, 1855-1865",
      category_b_id: 43,
      category_b_name: "Weekly U.S. and State Bond Prices, 1855-1865",
      popularity_sum: 23
    },
    {
      category_a_id: 5,
      category_a_name: "Sticky Wages and Comovement",
      category_b_id: 42,
      category_b_name: "Sticky Wages and Comovement",
      popularity_sum: 220
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 26,
      category_b_name: "Ratio of GNP to GDP",
      popularity_sum: 1782
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 25,
      category_b_name: "Exchange Rates",
      popularity_sum: 1344
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 31,
      category_b_name: "Price Levels of GDP, Consumption, Government, and Investment",
      popularity_sum: 769
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 35,
      category_b_name: "Real GDP per Capita (Constant Prices)",
      popularity_sum: 729
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 34,
      category_b_name: "Purchasing Power Parity",
      popularity_sum: 347
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 32,
      category_b_name: "Population",
      popularity_sum: 313
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 39,
      category_b_name: "Gross Domestic Income, Adjustments for Changes in Terms of Trade",
      popularity_sum: 219
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 28,
      category_b_name: "Openness",
      popularity_sum: 193
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 27,
      category_b_name: "Component Shares of GDP per Capita (Constant Prices)",
      popularity_sum: 180
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 24,
      category_b_name: "Component Shares of GDP per Capita (Current Prices)",
      popularity_sum: 126
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 37,
      category_b_name: "Real GDP per Worker",
      popularity_sum: 120
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 29,
      category_b_name: "GDP per Capita (Current Prices)",
      popularity_sum: 69
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 30,
      category_b_name: "Real GDP per Capita Relative to U.S.",
      popularity_sum: 37
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 41,
      category_b_name: "Real GDP per Hour Worked by Employees",
      popularity_sum: 14
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 36,
      category_b_name: "Real GDP per Equivalent Adult",
      popularity_sum: 7
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 40,
      category_b_name: "Real GDP per Person Counted in Total Employment",
      popularity_sum: 7
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 33,
      category_b_name: "Purchasing Power Parity Converted GDP",
      popularity_sum: 0
    },
    {
      category_a_id: 4,
      category_a_name: "Penn World Table 7.1",
      category_b_id: 38,
      category_b_name: "Real GDP per Person Engaged",
      popularity_sum: 0
    },
    {
      category_a_id: 3,
      category_a_name: "Economic Policy Uncertainty",
      category_b_id: 23,
      category_b_name: "Economic Policy Uncertainty",
      popularity_sum: 348
    },
    {
      category_a_id: 2,
      category_a_name: "Penn World Table 9.0",
      category_b_id: 20,
      category_b_name: "National Accounts-Based Variables",
      popularity_sum: 3312
    },
    {
      category_a_id: 2,
      category_a_name: "Penn World Table 9.0",
      category_b_id: 17,
      category_b_name: "Real GDP, Employment and Population Levels",
      popularity_sum: 1142
    },
    {
      category_a_id: 2,
      category_a_name: "Penn World Table 9.0",
      category_b_id: 18,
      category_b_name: "Current Price GDP, Capital and Total Factor Productivity",
      popularity_sum: 758
    },
    {
      category_a_id: 2,
      category_a_name: "Penn World Table 9.0",
      category_b_id: 21,
      category_b_name: "Price Levels, Expenditure Categories and Capital",
      popularity_sum: 555
    },
    {
      category_a_id: 2,
      category_a_name: "Penn World Table 9.0",
      category_b_id: 22,
      category_b_name: "Exchange Rates and GDP Price Levels",
      popularity_sum: 419
    },
    {
      category_a_id: 2,
      category_a_name: "Penn World Table 9.0",
      category_b_id: 19,
      category_b_name: "Shares in Output-side Real GDP at Current Purchasing Power Parities",
      popularity_sum: 158
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 8,
      category_b_name: "Income and Employment",
      popularity_sum: 2133
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 4,
      category_b_name: "Prices",
      popularity_sum: 2088
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 14,
      category_b_name: "Interest Rates",
      popularity_sum: 1148
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 2,
      category_b_name: "Construction",
      popularity_sum: 1053
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 12,
      category_b_name: "Money and Banking",
      popularity_sum: 996
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 1,
      category_b_name: "Production of Commodities",
      popularity_sum: 852
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 9,
      category_b_name: "Financial Status of Business",
      popularity_sum: 678
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 10,
      category_b_name: "Savings and Investment",
      popularity_sum: 669
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 15,
      category_b_name: "Government and Finance",
      popularity_sum: 593
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 6,
      category_b_name: "Distribution of Commodities",
      popularity_sum: 457
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 13,
      category_b_name: "Security Markets",
      popularity_sum: 418
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 5,
      category_b_name: "Stocks of Commodities",
      popularity_sum: 414
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 16,
      category_b_name: "Leading Indicators",
      popularity_sum: 333
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 3,
      category_b_name: "Transportation and Public Utilities",
      popularity_sum: 282
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 7,
      category_b_name: "Foreign Trade",
      popularity_sum: 277
    },
    {
      category_a_id: 1,
      category_a_name: "NBER Macrohistory Database",
      category_b_id: 11,
      category_b_name: "Volume of Transactions",
      popularity_sum: 71
    }
  ],
  ECUS_CATEGORYA: [
    {
      id: 3,
      category_a_name: "Money, Banking, & Finance"
    },
    {
      id: 2,
      category_a_name: "National Accounts"
    },
    {
      id: 7,
      category_a_name: "Others"
    },
    {
      id: 6,
      category_a_name: "Population, Employment, & Labor Markets"
    },
    {
      id: 5,
      category_a_name: "Prices"
    },
    {
      id: 1,
      category_a_name: "Production & Business Activity"
    },
    {
      id: 4,
      category_a_name: "U.S. Regional Data"
    }
  ],
  ECUS_CATEGORYB: [
    {
      category_a_id: 7,
      category_a_name: "Others",
      category_b_id: 50,
      category_b_name: "Others",
      popularity_sum: 0
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 39,
      category_b_name: "Current Population Survey (Household Survey)",
      popularity_sum: 11987
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 40,
      category_b_name: "Current Employment Statistics (Establishment Survey)",
      popularity_sum: 4856
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 43,
      category_b_name: "Productivity & Costs",
      popularity_sum: 3712
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 47,
      category_b_name: "Job Openings and Labor Turnover (JOLTS)",
      popularity_sum: 1564
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 46,
      category_b_name: "Income Distribution",
      popularity_sum: 1010
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 41,
      category_b_name: "Population",
      popularity_sum: 752
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 42,
      category_b_name: "Weekly Initial Claims",
      popularity_sum: 511
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 48,
      category_b_name: "ADP Employment",
      popularity_sum: 359
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 56,
      category_b_name: "Tax Data",
      popularity_sum: 359
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 44,
      category_b_name: "Labor Market Conditions",
      popularity_sum: 315
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 49,
      category_b_name: "Others",
      popularity_sum: 136
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 45,
      category_b_name: "Education",
      popularity_sum: 110
    },
    {
      category_a_id: 6,
      category_a_name: "Population, Employment, & Labor Markets",
      category_b_id: 55,
      category_b_name: "Minimum Wage",
      popularity_sum: 71
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 38,
      category_b_name: "Producer Price Indexes (PPI)",
      popularity_sum: 15769
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 36,
      category_b_name: "Consumer Price Indexes (CPI and PCE)",
      popularity_sum: 6498
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 31,
      category_b_name: "Commodities",
      popularity_sum: 4216
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 32,
      category_b_name: "Trade Indexes",
      popularity_sum: 2899
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 33,
      category_b_name: "House Price Indexes",
      popularity_sum: 2440
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 35,
      category_b_name: "Employment Cost Index",
      popularity_sum: 797
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 37,
      category_b_name: "Others",
      popularity_sum: 250
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 34,
      category_b_name: "Health Care Indexes",
      popularity_sum: 228
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 53,
      category_b_name: "Cryptocurrencies",
      popularity_sum: 125
    },
    {
      category_a_id: 5,
      category_a_name: "Prices",
      category_b_id: 54,
      category_b_name: "Prices",
      popularity_sum: 9
    },
    {
      category_a_id: 4,
      category_a_name: "U.S. Regional Data",
      category_b_id: 25,
      category_b_name: "States",
      popularity_sum: 144685
    },
    {
      category_a_id: 4,
      category_a_name: "U.S. Regional Data",
      category_b_id: 26,
      category_b_name: "Census Regions",
      popularity_sum: 1800
    },
    {
      category_a_id: 4,
      category_a_name: "U.S. Regional Data",
      category_b_id: 27,
      category_b_name: "Federal Reserve Districts",
      popularity_sum: 1157
    },
    {
      category_a_id: 4,
      category_a_name: "U.S. Regional Data",
      category_b_id: 28,
      category_b_name: "BEA Regions",
      popularity_sum: 767
    },
    {
      category_a_id: 4,
      category_a_name: "U.S. Regional Data",
      category_b_id: 30,
      category_b_name: "Freddie Mac Regions",
      popularity_sum: 336
    },
    {
      category_a_id: 4,
      category_a_name: "U.S. Regional Data",
      category_b_id: 29,
      category_b_name: "BLS Regions",
      popularity_sum: 203
    },
    {
      category_a_id: 3,
      category_a_name: "Money, Banking, & Finance",
      category_b_id: 18,
      category_b_name: "Interest Rates",
      popularity_sum: 19037
    },
    {
      category_a_id: 3,
      category_a_name: "Money, Banking, & Finance",
      category_b_id: 22,
      category_b_name: "Banking",
      popularity_sum: 11678
    },
    {
      category_a_id: 3,
      category_a_name: "Money, Banking, & Finance",
      category_b_id: 20,
      category_b_name: "Monetary Data",
      popularity_sum: 10341
    },
    {
      category_a_id: 3,
      category_a_name: "Money, Banking, & Finance",
      category_b_id: 21,
      category_b_name: "Financial Indicators",
      popularity_sum: 7171
    },
    {
      category_a_id: 3,
      category_a_name: "Money, Banking, & Finance",
      category_b_id: 23,
      category_b_name: "Exchange Rates",
      popularity_sum: 4382
    },
    {
      category_a_id: 3,
      category_a_name: "Money, Banking, & Finance",
      category_b_id: 19,
      category_b_name: "Business Lending",
      popularity_sum: 2042
    },
    {
      category_a_id: 3,
      category_a_name: "Money, Banking, & Finance",
      category_b_id: 24,
      category_b_name: "Foreign Exchange Intervention",
      popularity_sum: 390
    },
    {
      category_a_id: 2,
      category_a_name: "National Accounts",
      category_b_id: 14,
      category_b_name: "National Income & Product Accounts",
      popularity_sum: 37004
    },
    {
      category_a_id: 2,
      category_a_name: "National Accounts",
      category_b_id: 15,
      category_b_name: "Flow of Funds",
      popularity_sum: 12120
    },
    {
      category_a_id: 2,
      category_a_name: "National Accounts",
      category_b_id: 16,
      category_b_name: "U.S. Trade & International Transactions",
      popularity_sum: 2635
    },
    {
      category_a_id: 2,
      category_a_name: "National Accounts",
      category_b_id: 17,
      category_b_name: "Federal Government Debt",
      popularity_sum: 1631
    },
    {
      category_a_id: 2,
      category_a_name: "National Accounts",
      category_b_id: 52,
      category_b_name: "National Accounts",
      popularity_sum: 47
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 7,
      category_b_name: "Industrial Production & Capacity Utilization",
      popularity_sum: 5324
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 2,
      category_b_name: "Manufacturing",
      popularity_sum: 4104
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 5,
      category_b_name: "Housing",
      popularity_sum: 4095
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 8,
      category_b_name: "Retail Trade",
      popularity_sum: 3149
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 3,
      category_b_name: "Services",
      popularity_sum: 2378
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 4,
      category_b_name: "Transportation",
      popularity_sum: 2223
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 1,
      category_b_name: "Business Cycle Expansions & Contractions",
      popularity_sum: 1878
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 11,
      category_b_name: "Construction",
      popularity_sum: 1391
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 10,
      category_b_name: "Wholesale Trade",
      popularity_sum: 968
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 9,
      category_b_name: "Finance Companies",
      popularity_sum: 924
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 6,
      category_b_name: "Others",
      popularity_sum: 413
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 51,
      category_b_name: "Production & Business Activity",
      popularity_sum: 227
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 12,
      category_b_name: "Technology",
      popularity_sum: 113
    },
    {
      category_a_id: 1,
      category_a_name: "Production & Business Activity",
      category_b_id: 13,
      category_b_name: "Health Insurance",
      popularity_sum: 57
    }
  ],
  ECINTER_CATEGROYA: [
    {
      id: 1,
      category_a_name: "Countries"
    },
    {
      id: 4,
      category_a_name: "Geography"
    },
    {
      id: 3,
      category_a_name: "Indicators"
    },
    {
      id: 2,
      category_a_name: "Institutions"
    }
  ],
  ECINTER_CATEGROYB: [
    {
      category_a_id: 4,
      category_a_name: "Geography",
      category_b_id: 259,
      category_b_name: "World",
      popularity_sum: 488
    },
    {
      category_a_id: 4,
      category_a_name: "Geography",
      category_b_id: 273,
      category_b_name: "Geography",
      popularity_sum: 26
    },
    {
      category_a_id: 4,
      category_a_name: "Geography",
      category_b_id: 272,
      category_b_name: "Americas",
      popularity_sum: 8
    },
    {
      category_a_id: 4,
      category_a_name: "Geography",
      category_b_id: 275,
      category_b_name: "Europe",
      popularity_sum: 8
    },
    {
      category_a_id: 4,
      category_a_name: "Geography",
      category_b_id: 271,
      category_b_name: "Africa",
      popularity_sum: 4
    },
    {
      category_a_id: 4,
      category_a_name: "Geography",
      category_b_id: 274,
      category_b_name: "Oceania",
      popularity_sum: 2
    },
    {
      category_a_id: 4,
      category_a_name: "Geography",
      category_b_id: 276,
      category_b_name: "Asia",
      popularity_sum: 2
    },
    {
      category_a_id: 3,
      category_a_name: "Indicators",
      category_b_id: 255,
      category_b_name: "National Accounts",
      popularity_sum: 9423
    },
    {
      category_a_id: 3,
      category_a_name: "Indicators",
      category_b_id: 256,
      category_b_name: "Population, Employment, & Labor Markets",
      popularity_sum: 7885
    },
    {
      category_a_id: 3,
      category_a_name: "Indicators",
      category_b_id: 257,
      category_b_name: "Prices",
      popularity_sum: 3714
    },
    {
      category_a_id: 3,
      category_a_name: "Indicators",
      category_b_id: 258,
      category_b_name: "Production & Business Activity",
      popularity_sum: 718
    },
    {
      category_a_id: 3,
      category_a_name: "Indicators",
      category_b_id: 254,
      category_b_name: "Money, Banking, & Finance",
      popularity_sum: 630
    },
    {
      category_a_id: 3,
      category_a_name: "Indicators",
      category_b_id: 253,
      category_b_name: "Consumer Price Index",
      popularity_sum: 14
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 244,
      category_b_name: "Euro Area",
      popularity_sum: 2901
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 246,
      category_b_name: "European Union",
      popularity_sum: 688
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 241,
      category_b_name: "Bureau of Labor Statistics Industrialized Countries",
      popularity_sum: 245
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 252,
      category_b_name: "OECD Total",
      popularity_sum: 179
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 247,
      category_b_name: "Group of Seven (G7)",
      popularity_sum: 126
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 243,
      category_b_name: "Bureau of Labor Statistics Pacific Rim",
      popularity_sum: 125
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 251,
      category_b_name: "OECD - Europe",
      popularity_sum: 96
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 239,
      category_b_name: "Association of Southeast Asian Nations (ASEAN)",
      popularity_sum: 41
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 265,
      category_b_name: "Group of Twenty Finance Ministers and Central Bank Governors (G20)",
      popularity_sum: 39
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 242,
      category_b_name: "Bureau of Labor Statistics Latin America",
      popularity_sum: 37
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 248,
      category_b_name: "Major 5 Asia",
      popularity_sum: 31
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 240,
      category_b_name: "Bureau of Labor Statistics Asian Newly Industrialized Countries",
      popularity_sum: 25
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 266,
      category_b_name: "NAFTA",
      popularity_sum: 19
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 249,
      category_b_name: "Non-OECD",
      popularity_sum: 18
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 250,
      category_b_name: "OECD + Non-member Economies",
      popularity_sum: 15
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 245,
      category_b_name: "European Economic Area",
      popularity_sum: 14
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 264,
      category_b_name: "Four Big European Countries",
      popularity_sum: 5
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 268,
      category_b_name: "International Organizations",
      popularity_sum: 4
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 270,
      category_b_name: "Advance Technology Products",
      popularity_sum: 4
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 267,
      category_b_name: "NICS",
      popularity_sum: 1
    },
    {
      category_a_id: 2,
      category_a_name: "Institutions",
      category_b_id: 269,
      category_b_name: "Unidentified Countries",
      popularity_sum: 0
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 226,
      category_b_name: "United States",
      popularity_sum: 12660
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 105,
      category_b_name: "Japan",
      popularity_sum: 6869
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 225,
      category_b_name: "United Kingdom",
      popularity_sum: 5350
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 77,
      category_b_name: "Germany",
      popularity_sum: 5030
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 43,
      category_b_name: "China",
      popularity_sum: 4776
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 36,
      category_b_name: "Canada",
      popularity_sum: 4133
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 71,
      category_b_name: "France",
      popularity_sum: 3248
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 199,
      category_b_name: "Spain",
      popularity_sum: 2920
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 12,
      category_b_name: "Australia",
      popularity_sum: 2636
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 103,
      category_b_name: "Italy",
      popularity_sum: 2540
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 111,
      category_b_name: "Korea, Republic of (South Korea)",
      popularity_sum: 2537
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 218,
      category_b_name: "Turkey",
      popularity_sum: 2437
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 137,
      category_b_name: "Mexico",
      popularity_sum: 2345
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 175,
      category_b_name: "Russian Federation",
      popularity_sum: 2301
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 28,
      category_b_name: "Brazil",
      popularity_sum: 2227
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 205,
      category_b_name: "Sweden",
      popularity_sum: 1790
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 97,
      category_b_name: "Indonesia",
      popularity_sum: 1620
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 197,
      category_b_name: "South Africa",
      popularity_sum: 1616
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 96,
      category_b_name: "India",
      popularity_sum: 1560
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 206,
      category_b_name: "Switzerland",
      popularity_sum: 1465
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 80,
      category_b_name: "Greece",
      popularity_sum: 1458
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 168,
      category_b_name: "Poland",
      popularity_sum: 1385
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 9,
      category_b_name: "Argentina",
      popularity_sum: 1125
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 186,
      category_b_name: "Saudi Arabia",
      popularity_sum: 1048
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 157,
      category_b_name: "Norway",
      popularity_sum: 993
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 13,
      category_b_name: "Austria",
      popularity_sum: 937
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 100,
      category_b_name: "Ireland",
      popularity_sum: 933
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 57,
      category_b_name: "Denmark",
      popularity_sum: 911
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 42,
      category_b_name: "Chile",
      popularity_sum: 892
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 128,
      category_b_name: "Malaysia",
      popularity_sum: 869
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 191,
      category_b_name: "Singapore",
      popularity_sum: 784
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 20,
      category_b_name: "Belgium",
      popularity_sum: 763
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 70,
      category_b_name: "Finland",
      popularity_sum: 760
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 150,
      category_b_name: "Netherlands",
      popularity_sum: 755
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 46,
      category_b_name: "Colombia",
      popularity_sum: 698
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 169,
      category_b_name: "Portugal",
      popularity_sum: 686
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 211,
      category_b_name: "Thailand",
      popularity_sum: 644
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 55,
      category_b_name: "Czech Republic",
      popularity_sum: 604
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 102,
      category_b_name: "Israel",
      popularity_sum: 590
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 166,
      category_b_name: "Philippines",
      popularity_sum: 578
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 159,
      category_b_name: "Pakistan",
      popularity_sum: 515
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 231,
      category_b_name: "Viet Nam",
      popularity_sum: 466
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 17,
      category_b_name: "Bangladesh",
      popularity_sum: 454
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 94,
      category_b_name: "Hungary",
      popularity_sum: 453
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 152,
      category_b_name: "New Zealand",
      popularity_sum: 453
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 155,
      category_b_name: "Nigeria",
      popularity_sum: 404
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 95,
      category_b_name: "Iceland",
      popularity_sum: 375
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 224,
      category_b_name: "United Arab Emirates",
      popularity_sum: 373
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 174,
      category_b_name: "Romania",
      popularity_sum: 362
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 123,
      category_b_name: "Luxembourg",
      popularity_sum: 333
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 230,
      category_b_name: "Venezuela, Bolivarian Republic of",
      popularity_sum: 326
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 176,
      category_b_name: "Rwanda",
      popularity_sum: 320
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 98,
      category_b_name: "Iran, Islamic Republic of",
      popularity_sum: 318
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 67,
      category_b_name: "Ethiopia",
      popularity_sum: 317
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 171,
      category_b_name: "Qatar",
      popularity_sum: 309
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 122,
      category_b_name: "Lithuania",
      popularity_sum: 302
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 108,
      category_b_name: "Kenya",
      popularity_sum: 283
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 146,
      category_b_name: "Myanmar",
      popularity_sum: 266
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 31,
      category_b_name: "Bulgaria",
      popularity_sum: 257
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 116,
      category_b_name: "Latvia",
      popularity_sum: 253
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 93,
      category_b_name: "Hong Kong",
      popularity_sum: 251
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 165,
      category_b_name: "Peru",
      popularity_sum: 248
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 62,
      category_b_name: "Egypt",
      popularity_sum: 242
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 193,
      category_b_name: "Slovak Republic",
      popularity_sum: 238
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 33,
      category_b_name: "Burundi",
      popularity_sum: 224
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 78,
      category_b_name: "Ghana",
      popularity_sum: 218
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 238,
      category_b_name: "Zimbabwe",
      popularity_sum: 211
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 34,
      category_b_name: "Cambodia",
      popularity_sum: 208
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 141,
      category_b_name: "Mongolia",
      popularity_sum: 203
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 66,
      category_b_name: "Estonia",
      popularity_sum: 201
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 14,
      category_b_name: "Azerbaijan",
      popularity_sum: 198
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 50,
      category_b_name: "Costa Rica",
      popularity_sum: 194
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 6,
      category_b_name: "Angola",
      popularity_sum: 189
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 107,
      category_b_name: "Kazakhstan",
      popularity_sum: 168
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 115,
      category_b_name: "Lao People's Democratic Republic",
      popularity_sum: 168
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 125,
      category_b_name: "Macedonia, Former Yugoslav Republic of",
      popularity_sum: 168
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 3,
      category_b_name: "Algeria",
      popularity_sum: 167
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 194,
      category_b_name: "Slovenia",
      popularity_sum: 167
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 99,
      category_b_name: "Iraq",
      popularity_sum: 161
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 170,
      category_b_name: "Puerto Rico",
      popularity_sum: 154
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 60,
      category_b_name: "Dominican Republic",
      popularity_sum: 149
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 223,
      category_b_name: "Ukraine",
      popularity_sum: 148
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 35,
      category_b_name: "Cameroon",
      popularity_sum: 146
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 210,
      category_b_name: "Tanzania, United Republic of",
      popularity_sum: 146
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 1,
      category_b_name: "Afghanistan",
      popularity_sum: 140
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 25,
      category_b_name: "Bolivia, Plurinational State of",
      popularity_sum: 140
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 61,
      category_b_name: "Ecuador",
      popularity_sum: 140
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 113,
      category_b_name: "Kuwait",
      popularity_sum: 139
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 228,
      category_b_name: "Uzbekistan",
      popularity_sum: 137
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 126,
      category_b_name: "Madagascar",
      popularity_sum: 135
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 149,
      category_b_name: "Nepal",
      popularity_sum: 130
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 237,
      category_b_name: "Zambia",
      popularity_sum: 113
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 30,
      category_b_name: "Brunei Darussalam",
      popularity_sum: 107
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 104,
      category_b_name: "Jamaica",
      popularity_sum: 107
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 117,
      category_b_name: "Lebanon",
      popularity_sum: 107
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 48,
      category_b_name: "Congo, Democratic Republic of the",
      popularity_sum: 106
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 222,
      category_b_name: "Uganda",
      popularity_sum: 106
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 106,
      category_b_name: "Jordan",
      popularity_sum: 104
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 16,
      category_b_name: "Bahrain",
      popularity_sum: 103
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 110,
      category_b_name: "Korea, Democratic People's Republic of (North Korea)",
      popularity_sum: 101
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 208,
      category_b_name: "Taiwan",
      popularity_sum: 101
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 10,
      category_b_name: "Armenia",
      popularity_sum: 99
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 217,
      category_b_name: "Tunisia",
      popularity_sum: 98
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 112,
      category_b_name: "Kosovo",
      popularity_sum: 94
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 236,
      category_b_name: "Yemen, Republic of",
      popularity_sum: 94
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 52,
      category_b_name: "Cuba",
      popularity_sum: 91
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 131,
      category_b_name: "Malta",
      popularity_sum: 90
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 2,
      category_b_name: "Albania",
      popularity_sum: 89
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 54,
      category_b_name: "Cyprus",
      popularity_sum: 88
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 56,
      category_b_name: "C\u00f4te d\u2019Ivoire",
      popularity_sum: 88
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 85,
      category_b_name: "Guatemala",
      popularity_sum: 86
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 161,
      category_b_name: "Palestinian Territories",
      popularity_sum: 86
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 200,
      category_b_name: "Sri Lanka",
      popularity_sum: 86
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 120,
      category_b_name: "Libyan Arab Jamahiriya",
      popularity_sum: 84
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 51,
      category_b_name: "Croatia",
      popularity_sum: 82
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 144,
      category_b_name: "Morocco",
      popularity_sum: 81
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 118,
      category_b_name: "Lesotho",
      popularity_sum: 80
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 127,
      category_b_name: "Malawi",
      popularity_sum: 80
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 139,
      category_b_name: "Moldova, Republic of",
      popularity_sum: 79
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 153,
      category_b_name: "Nicaragua",
      popularity_sum: 77
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 158,
      category_b_name: "Oman",
      popularity_sum: 74
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 69,
      category_b_name: "Fiji",
      popularity_sum: 71
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 145,
      category_b_name: "Mozambique",
      popularity_sum: 69
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 22,
      category_b_name: "Benin",
      popularity_sum: 64
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 24,
      category_b_name: "Bhutan",
      popularity_sum: 64
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 27,
      category_b_name: "Botswana",
      popularity_sum: 64
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 47,
      category_b_name: "Comoros",
      popularity_sum: 63
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 114,
      category_b_name: "Kyrgyz Republic",
      popularity_sum: 62
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 189,
      category_b_name: "Seychelles",
      popularity_sum: 62
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 163,
      category_b_name: "Papua New Guinea",
      popularity_sum: 59
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 15,
      category_b_name: "Bahamas",
      popularity_sum: 57
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 119,
      category_b_name: "Liberia",
      popularity_sum: 56
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 135,
      category_b_name: "Mauritius",
      popularity_sum: 56
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 201,
      category_b_name: "Sudan",
      popularity_sum: 56
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 213,
      category_b_name: "Togo",
      popularity_sum: 56
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 41,
      category_b_name: "Chad",
      popularity_sum: 55
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 86,
      category_b_name: "Guinea",
      popularity_sum: 55
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 92,
      category_b_name: "Honduras",
      popularity_sum: 55
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 188,
      category_b_name: "Serbia",
      popularity_sum: 55
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 207,
      category_b_name: "Syrian Arab Republic",
      popularity_sum: 55
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 88,
      category_b_name: "Guyana",
      popularity_sum: 53
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 129,
      category_b_name: "Maldives",
      popularity_sum: 53
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 11,
      category_b_name: "Aruba",
      popularity_sum: 52
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 172,
      category_b_name: "Republic of the Gambia",
      popularity_sum: 49
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 227,
      category_b_name: "Uruguay",
      popularity_sum: 49
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 162,
      category_b_name: "Panama",
      popularity_sum: 48
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 142,
      category_b_name: "Montenegro",
      popularity_sum: 47
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 32,
      category_b_name: "Burkina Faso",
      popularity_sum: 46
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 209,
      category_b_name: "Tajikistan",
      popularity_sum: 45
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 229,
      category_b_name: "Vanuatu",
      popularity_sum: 45
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 89,
      category_b_name: "Haiti",
      popularity_sum: 44
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 187,
      category_b_name: "Senegal",
      popularity_sum: 44
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 76,
      category_b_name: "Georgia",
      popularity_sum: 41
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 75,
      category_b_name: "Gabon",
      popularity_sum: 40
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 196,
      category_b_name: "Somalia",
      popularity_sum: 40
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 63,
      category_b_name: "El Salvador",
      popularity_sum: 39
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 134,
      category_b_name: "Mauritania",
      popularity_sum: 39
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 216,
      category_b_name: "Trinidad and Tobago",
      popularity_sum: 39
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 26,
      category_b_name: "Bosnia and Herzegovina",
      popularity_sum: 38
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 140,
      category_b_name: "Monaco",
      popularity_sum: 38
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 18,
      category_b_name: "Barbados",
      popularity_sum: 37
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 64,
      category_b_name: "Equatorial Guinea",
      popularity_sum: 37
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 65,
      category_b_name: "Eritrea",
      popularity_sum: 37
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 204,
      category_b_name: "Swaziland",
      popularity_sum: 37
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 82,
      category_b_name: "Grenada",
      popularity_sum: 36
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 185,
      category_b_name: "Sao Tome and Principe",
      popularity_sum: 36
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 183,
      category_b_name: "Samoa",
      popularity_sum: 35
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 58,
      category_b_name: "Djibouti",
      popularity_sum: 33
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 219,
      category_b_name: "Turkmenistan",
      popularity_sum: 33
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 130,
      category_b_name: "Mali",
      popularity_sum: 32
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 147,
      category_b_name: "Namibia",
      popularity_sum: 32
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 40,
      category_b_name: "Central African Republic",
      popularity_sum: 31
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 154,
      category_b_name: "Niger",
      popularity_sum: 31
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 198,
      category_b_name: "South Sudan",
      popularity_sum: 31
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 212,
      category_b_name: "Timor-Leste",
      popularity_sum: 31
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 19,
      category_b_name: "Belarus",
      popularity_sum: 30
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 37,
      category_b_name: "Cape Verde",
      popularity_sum: 30
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 164,
      category_b_name: "Paraguay",
      popularity_sum: 28
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 109,
      category_b_name: "Kiribati",
      popularity_sum: 27
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 124,
      category_b_name: "Macao",
      popularity_sum: 26
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 8,
      category_b_name: "Antigua and Barbuda",
      popularity_sum: 24
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 215,
      category_b_name: "Tonga",
      popularity_sum: 24
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 49,
      category_b_name: "Congo, Republic of the",
      popularity_sum: 20
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 190,
      category_b_name: "Sierra Leone",
      popularity_sum: 20
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 233,
      category_b_name: "Virgin Islands, U.S.",
      popularity_sum: 20
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 87,
      category_b_name: "Guinea-Bissau",
      popularity_sum: 18
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 138,
      category_b_name: "Micronesia, Federated States of",
      popularity_sum: 18
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 21,
      category_b_name: "Belize",
      popularity_sum: 16
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 39,
      category_b_name: "Cayman Islands",
      popularity_sum: 16
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 59,
      category_b_name: "Dominica",
      popularity_sum: 16
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 202,
      category_b_name: "Suriname",
      popularity_sum: 13
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 79,
      category_b_name: "Gibraltar",
      popularity_sum: 12
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 101,
      category_b_name: "Isle of Man",
      popularity_sum: 11
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 195,
      category_b_name: "Solomon Islands",
      popularity_sum: 10
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 121,
      category_b_name: "Liechtenstein",
      popularity_sum: 9
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 132,
      category_b_name: "Marshall Islands",
      popularity_sum: 9
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 179,
      category_b_name: "Saint Lucia",
      popularity_sum: 9
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 182,
      category_b_name: "Saint Vincent and the Grenadines",
      popularity_sum: 9
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 7,
      category_b_name: "Anguilla",
      popularity_sum: 8
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 23,
      category_b_name: "Bermuda",
      popularity_sum: 8
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 221,
      category_b_name: "Tuvalu",
      popularity_sum: 8
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 160,
      category_b_name: "Palau",
      popularity_sum: 7
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 143,
      category_b_name: "Montserrat",
      popularity_sum: 6
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 184,
      category_b_name: "San Marino",
      popularity_sum: 6
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 178,
      category_b_name: "Saint Kitts and Nevis",
      popularity_sum: 5
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 72,
      category_b_name: "French Guiana",
      popularity_sum: 3
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 5,
      category_b_name: "Andorra",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 29,
      category_b_name: "British Indian Ocean Territory",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 44,
      category_b_name: "Christmas Island",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 68,
      category_b_name: "Faroe Islands",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 81,
      category_b_name: "Greenland",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 91,
      category_b_name: "Holy See (Vatican City State)",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 133,
      category_b_name: "Martinique",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 167,
      category_b_name: "Pitcairn",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 177,
      category_b_name: "Saint Helena, Ascension and Tristan da Cunha",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 181,
      category_b_name: "Saint Pierre and Miquelon",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 192,
      category_b_name: "Sint Maarten (Dutch part)",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 214,
      category_b_name: "Tokelau",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 220,
      category_b_name: "Turks and Caicos Islands",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 232,
      category_b_name: "Virgin Islands, British",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 234,
      category_b_name: "Wallis and Futuna",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 235,
      category_b_name: "Western Sahara",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 263,
      category_b_name: "Falkland Islands",
      popularity_sum: 2
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 45,
      category_b_name: "Cocos (Keeling) Islands",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 73,
      category_b_name: "French Polynesia",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 74,
      category_b_name: "French Southern Territories",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 83,
      category_b_name: "Guadeloupe",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 90,
      category_b_name: "Heard Island and McDonald Islands",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 136,
      category_b_name: "Mayotte",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 148,
      category_b_name: "Nauru",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 151,
      category_b_name: "New Caledonia",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 260,
      category_b_name: "Niue",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 261,
      category_b_name: "Norfolk Island",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 262,
      category_b_name: "Cook Islands",
      popularity_sum: 1
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 4,
      category_b_name: "American Samoa",
      popularity_sum: 0
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 38,
      category_b_name: "Caribbean Netherlands",
      popularity_sum: 0
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 53,
      category_b_name: "Cura\u00e7ao",
      popularity_sum: 0
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 84,
      category_b_name: "Guam",
      popularity_sum: 0
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 156,
      category_b_name: "Northern Mariana Islands",
      popularity_sum: 0
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 173,
      category_b_name: "Reunion",
      popularity_sum: 0
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 180,
      category_b_name: "Saint Martin, Collectivity of",
      popularity_sum: 0
    },
    {
      category_a_id: 1,
      category_a_name: "Countries",
      category_b_id: 203,
      category_b_name: "Svalbard and Jan Mayen",
      popularity_sum: 0
    }
  ],
  CompanyFinancials_CATEGORY_IS: {
    "total revenue": 0,
    "cost of revenue": 1,
    "gross profit": 2,
    "non recurring expense": 3,
    "research expense": 4,
    "selling admin expense": 5,
    // non recurring
    "other expense": 6,
    "total operating expense": 7,
    "operating income": 8,
    "total other income net": 9,
    "earnings before interest taxes": 10,
    "interest expense": 11,
    "income before tax": 12,
    "income tax expense": 13,
    "minority interest": 14,
    "net income continuing op": 15,
    "discontinued operation": 16,
    "extraordinary item": 17,
    "effect account change": 18,
    "other item": 19,
    "preferred stock other adj": 20,
    "net income": 21,
    "net income common share": 22,
    "adujustments net income": 23 // spelling error
  },

  CompanyFinancials_CATEGORY_BS: {
    "cash and equivalent": 0,
    "short term investment": 1,
    "net receivable": 2,
    inventory: 3,
    "other current asset": 4,
    "total current asset": 5,
    "long term investments": 6,
    "property plant equipment": 7,
    goodwill: 8,
    "intangible asset": 9,
    "accumulate amortization": 10,
    "other asset": 11,
    "deferred long term asset charge": 12,
    "total assets": 13,
    "account payable": 14,
    "short current long term debt": 15,
    "other current liability": 16,
    "total current liability": 17,
    "long term debt": 18,
    "other liabilities": 19,
    "defferred long term liability charges": 20,
    "minority interest": 21, // occured twice
    "nagative goodwill": 22, // spelling error!
    "total liabilities": 23
    // .. missing whole chunck of 'stockholder's equity'
  },

  CompanyFinancials_CATEGORY_CF: {
    "cashflow net income": 0,
    depreciation: 1,
    // adjustments to net income
    "changes in accounts receivables": 2,
    "changes liabilities": 3,
    "changes inventories": 4,
    "changes other operating activities": 5,
    "total cash flow operating": 6,
    "capital expenditures": 7,
    investments: 8,
    "other cashflowsfrom investing activities": 9,
    "total cashflowsfrom investing activities": 10,
    "dividends paid": 11,
    "sale purchase stock": 12,
    "net borrowings": 13,
    "other cashflowsfrom financing activities": 14,
    "total cashflowsfrom financing activities": 15,
    "effectof exchange ratechanges": 16,
    "change in cash equivalents": 17
  },
  API_CREDITS_MAP: {
    // 'US Realtime Stock Price': { perDataCredits: 1, points: 0, max: 10 ** 7 },
    "Realtime Stock Price": { perDataCredits: 1, points: 0, max: 10 ** 7 },
    "Historical Stock Price": {
      perDataCredits: 10,
      points: 0,
      max: 10 ** 6
    },
    "Company Financials": { perDataCredits: 100, points: 0, max: 10 ** 5 },
    "Company Profile": { perDataCredits: 10, points: 0, max: 10 ** 4 },
    "Company Financial Summary": {
      perDataCredits: 10,
      points: 0,
      max: 10 ** 4
    },
    "Ownership Structure": {
      perDataCredits: 300,
      points: 0,
      max: 10 ** 4
    },
    "Insider Transaction": {
      perDataCredits: 300,
      points: 0,
      max: 10 ** 5
    },
    "SEC Filing Link": { perDataCredits: 1, points: 0, max: 10 ** 5 },
    "Stock News": { perDataCredits: 100, points: 0, max: 10 ** 5 },

    "Corporate Splits": { perDataCredits: 100, points: 0, max: 10 ** 5 },
    "Corporate Dividends": { perDataCredits: 100, points: 0, max: 10 ** 5 },
    "Stock Analyst Ratings": { perDataCredits: 10000, points: 0, max: 10 ** 5 },
    Forex: { perDataCredits: 1, points: 0, max: 10 ** 5 },
    "Historical Crypto Price": {
      perDataCredits: 10,
      points: 0,
      max: 10 ** 6
    }
  }
};

const companyInfoProfileFields = [
  "Company Name",
  "Address",
  "Phone",
  "Website",
  "Sector",
  "Industry",
  "Employee Number",
  "Executive1 Name",
  "Executive1 Title",
  "Executive1 Pay",
  "Executive1 Exercised",
  "Executive1 Yearborn",
  "Executive2 Name",
  "Executive2 Title",
  "Executive2 Pay",
  "Executive2 Exercised",
  "Executive2 Yearborn",
  "Executive3 Name",
  "Executive3 Title",
  "Executive3 Pay",
  "Executive3 Exercised",
  "Executive3 Yearborn",
  "Executive4 Name",
  "Executive4 Title",
  "Executive4 Pay",
  "Executive4 Exercised",
  "Executive4 Yearborn",
  "Executive5 Name",
  "Executive5 Title",
  "Executive5 Pay",
  "Executive5 Exercised",
  "Executive5 Yearborn",
  "Company Description"
];

const companyFinancialsFields = [
  "Report Date",
  "Gross Profit",
  "Cost Of Revenue",
  "Total Revenue",
  "Research Expense",
  "Other Expense",
  "Total Operating Expense",
  "Selling Admin Expense",
  "Non Recurring Expense",
  "Operating Income",
  "Total Other Income Net",
  "Earnings Before Interest Taxes",
  "Interest Expense",
  "Income Before Tax",
  "Income Tax Expense",
  "Minority Interest",
  "Net Income Continuing Op",
  "Discontinued Operation",
  "Extraordinary Item",
  "Effect Account Change",
  "Other Item",
  "Net Income",
  "Preferred Stock Other Adj",
  "Net Income Common Share",
  "Cash And Equivalent",
  "Short Term Investment",
  "Net Receivable",
  "Inventory",
  "Other Current Asset",
  "Total Current Asset",
  "Long Term Investments",
  "Property Plant Equipment",
  "Goodwill",
  "Intangible Asset",
  "Accumulate Amortization",
  "Other Asset",
  "Deferred Long Term Asset Charge",
  "Total Assets",
  "Account Payable",
  "Short Current Long Term Debt",
  "Other Current Liability",
  "Total Current Liability",
  "Long Term Debt",
  "Other Liabilities",
  "Defferred Long Term Liability Charges",
  "Nagative Goodwill",
  "Total Liabilities",
  "Cashflow Net Income",
  "Depreciation",
  "Adujustments Net Income",
  "Changes In Accounts Receivables",
  "Changes Liabilities",
  "Changes Inventories",
  "Changes Other Operating Activities",
  "Total Cash Flow Operating",
  "Capital Expenditures",
  "Investments",
  "Other Cashflowsfrom Investing Activities",
  "Total Cashflowsfrom Investing Activities",
  "Dividends Paid",
  "Sale Purchase Stock",
  "Net Borrowings",
  "Effectof Exchange Ratechanges",
  "Other Cashflowsfrom Financing Activities",
  "Total Cashflowsfrom Financing Activities",
  "Change In Cash Equivalents"
];

const majorHolderFields = [
  "datetime",
  "Number of Institutions Holding Shares",
  "% of Shares Held by All Insider",
  "% of Shares Held by Institutions",
  "% of Float Held by Institutions"
];
const topHolderFields = ["Holder", "Value", "Date Reported", "% Out", "Shares"];

export const forexApiMap = {
  "Realtime Forex Price": ["Datetime", "Base Currency", "Target Currency", "Amount"]
};

export const apiNameFieldsMap = {
  "Realtime Stock Price": ["Minute", "Volume", "Price", "Timezone", "Gmt Offset"],
  "Historical Stock Price": ["Date", "Open", "High", "Low", "Close", "Volume"],
  "Technical Indicators": TECHNICAL_INDICATORS,
  "SEC Filing Link": ["Cik", "Type", "Datetime", "Txturl", "Docurl"],
  "Insider Transaction": [
    "Filing Date",
    "Trade Date",
    "Insider Name",
    "Insider Title",
    "Trade Type",
    "Price",
    "Quantity",
    "Change Own",
    "Value"
  ],
  "News by Sentiment": [
    "Sentiment",
    "Title",
    "Author",
    "Description",
    "Source",
    "Source Url",
    "Published Time"
  ],
  "News by Classification": [
    "Event Genre",
    "Event Sector",
    "Title",
    "Author",
    "Description",
    "Source",
    "Source Url",
    "Published Time"
  ],
  "News by Name Entities": [
    "Event Organization",
    "Event Person",
    "Event Location",
    "Title",
    "Author",
    "Description",
    "Source",
    "Source Url",
    "Published Time"
  ],
  "Company Profile": companyInfoProfileFields,
  "Company Financials": [
    ["Annual", companyFinancialsFields],
    ["Quarterly", companyFinancialsFields]
  ],
  "Ownership Structure": [
    ["Majority Holder", majorHolderFields],
    ["Top Institutional Holder", topHolderFields],
    ["Top Mutual Fund Holder", topHolderFields]
  ],
  "Company Financial Summary": [
    "Date Time",
    "Open",
    "Previous Close",
    "Market Cap",
    "Ask",
    "Forward Dividend Yield",
    "Avg Volume",
    "Ex Dividend Date",
    "Beta",
    "Bid",
    "Pe Ratio",
    "Eps",
    "Week 52 Range",
    "Earnings Date"
  ]
};

const getCategoryABList = area => {
  let categoryAList, categoryBList;
  if (area === "u.s") {
    categoryAList = globalConstants.ECUS_CATEGORYA;
    categoryBList = globalConstants.ECUS_CATEGORYB;
  } else if (area === "academic") {
    categoryAList = globalConstants.ECAD_CATEGORYA;
    categoryBList = globalConstants.ECAD_CATEGORYB;
  } else {
    categoryAList = globalConstants.ECINTER_CATEGROYA;
    categoryBList = globalConstants.ECINTER_CATEGROYB;
  }
  return { categoryAList, categoryBList };
};

const getCategoryBNameList = (categoryAId, categoryBList) => {
  const nameList = categoryBList
    .filter(el => el.category_a_id === categoryAId)
    .sort((a, b) => a.popularity_sum - b.popularity_sum)
    .map(el => el.category_b_name);
  return nameList;
};

const getCategoryABMap = area => {
  let categoryABMap = {};
  const { categoryAList, categoryBList } = getCategoryABList(area);
  categoryAList.forEach(el => {
    const name = el["category_a_name"];
    const id = el["id"];
    categoryABMap[name] = getCategoryBNameList(id, categoryBList);
  });
  return categoryABMap;
};

const getEcInincatorsApiMap = () => {
  let ecInincatorsApiMap = {};
  ecInincatorsApiMap["U.S Data"] = getCategoryABMap("u.s");
  ecInincatorsApiMap["International Data"] = getCategoryABMap("international");
  ecInincatorsApiMap["Academic Data"] = getCategoryABMap("academic");
  return ecInincatorsApiMap;
};

export const ecInincatorsApiMap = getEcInincatorsApiMap();

export const threeLevelApiMenuInfo = {
  "Company Financials": { showSecondMenu: false, showThirdMenu: false },
  "Ownership Structure": { showSecondMenu: false, showThirdMenu: false }
};

// map snake case string to uppercase with space
// fields.map(el => el.split('_').map(string => string.charAt(0).toUpperCase() + string.slice(1)).join(' '))
export const introductionTutorialSteps = () => {
  return {
    steps: [
      {
        intro:
          "Welcome to UniBit! Get ready for a quick tutorial of our Market Search Engine. This tutorial will explain each function in sequence. You may skip it and revisit it at any time."
      },
      {
        intro:
          'First, insert a ticker or company’s name here. For example, "MSFT", or Microsoft. You may select as many tickers as you want (the system may take more seconds to react if selected too many), or click the dropdown menu for recommended tickers and common indices such as Dow Jones 30, Nasdaq 100, etc.',
        element: document.querySelector(".control-input-asset")
      },
      {
        intro:
          'Click the dropdown menu here for all available market indicators. Each indicator comes with subsets. For example, "Company Financials" contains over 60 data fields such as "Total Revenue" and "Net Income". You may select only the ones you want.',
        element: document.querySelector(".control-input-indicator")
      },
      {
        intro:
          "Here you may specify the time range for your assets' indicators. Please be aware, the longer the range, the more time the system may take to compute.",
        element: document.querySelector(".control-input-daterange")
      },
      {
        intro: "Execute your search! Also, you may reset your search inputs.",
        element: document.querySelector(".panel-button")
      },
      {
        intro: `Terminal Console here returns all the requested datasets. You may also conduct some basic data manipulations here:
                        1. Rank: Click the Data Field to rank the rows from small to large or A to Z.
                        2. Classify and Filter: Input a keyword to search through the entire dataset or individual column. If it is a numerical value, you may also specify a range.
                        3. Interaction: You may drag each Data Field to positions you want.`,
        element: document.querySelector(".terminal-data-table")
      },
      {
        intro: `Here is the Task Bar:
                        1. Chart: Most datasets come with an interactive chart. Click the button to see the dataset in visuals.
                        2. API: You can request each customized dataset via API with your credit.
                        3. CSV: Here you may download the dataset in one click with your credit.`,
        element: document.querySelector(".icon-group")
      },
      {
        intro: `Bookmark helps you to save search queries and manage them. Every bookmark is encrypted and only visible to you.
                        1. Create a Bookmark: When you have queries in the search boxes, you may create a new bookmark or update an existing one.
                        2. Load a Bookmark: Here you may load an existing bookmark.
                        3. Current Bookmark: After you’ve loaded a bookmark, this will display the current bookmark name.`,
        element: document.querySelector(".bookmark-control")
      }
    ]
  };
};

export default globalConstants;



// WEBPACK FOOTER //
// ./src/utils/global-constants.js